import * as React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { HEADER_HEIGHT } from 'taskpane/utils/constants'

const Account = React.lazy(() => import('./routes/Account'))
const MyWrangles = React.lazy(() => import('./routes/MyWrangles'))

export interface AppProps {
  myWranglesPath?: string
}

const taskpane: React.FunctionComponent<AppProps> = ({
  myWranglesPath = '/',
}) => {
  const [searchText, setSearchText] = React.useState('')

  return (
    <BrowserRouter>
      <React.Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/account.html" element={<Account />} />
          <Route
            path={myWranglesPath}
            element={
              <MyWrangles
                stickyHeight={HEADER_HEIGHT}
                searchText={searchText}
                setSearchText={setSearchText}
              />
            }
          />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  )
}

export default taskpane
